import { Moment } from 'moment';

export const getTimeWithTimezoneOfSpecificDateAsString = ({
	time,
	date,
}: {
	time: Moment;
	date: Moment;
}) => {
	return time.format('HH:mm') + date.format('Z');
};
